import React, { Component } from "react";

import "./Dashboard.css";

class ITWSLiveTradingCard extends Component
{
    render()
    {
        return(


                <div className="card itws-card shadow">

                <div className="card-body">

                    <div className="itws-header">

                        <div className="itws-icon">
                            🖥
                        </div>

                        <div>

                            <h3>iDWS Desktop Workstation</h3>

                            <p>

                                Enterprise connectivity for IBKR - Interactive Brokers
                                integrated with the iDMS Trading Intelligence Platform.

                            </p>

                        </div>

                    </div>

                    <div className="row mt-4">

                        <div className="col-md-6">

                            <h5 className="section-title">
                                Enterprise Connectivity
                            </h5>

                            <ul className="feature-list">

                                <li>✓ &nbsp;&nbsp;&nbsp;Real-Time Transaction Routing</li>

                                <li>✓ &nbsp;&nbsp;&nbsp;Multi-Asset Trading Platform</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Secure Broker Communication</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Automated Order Synchronization</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Multi-Account Connectivity</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Copy Trading Workflows</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Signal Distribution</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Live Portfolio Monitoring</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Order Lifecycle Tracking</li>

                                <li>✓ &nbsp;&nbsp;&nbsp; Cloud Infrastructure Integration</li>

                            </ul>

                        </div>

                        <div className="col-md-6">

                            <h5 className="section-title">

                                Intelligent Risk Management

                            </h5>

                            <ul className="feature-list">

                                <li>🛡 Dynamic Stop Loss </li>

                                <li>🎯 Adaptive Profit Target</li>

                                <li>⏱ Time Risk Management</li>

                                <li>📊 Position Risk Assessment</li>

                                <li>📉 Portfolio Exposure Control</li>

                                <li>⚖ Trade Validation Engine</li>

                            </ul>

                        </div>

                    </div>

                    <hr/>

                    <div className="row align-items-center">

                        <div className="col-md-8">

                            <div className="version-panel">

                                <div>

                                    <small>Version</small>

                                    <strong>2.0.0</strong>

                                </div>

                                <div>

                                    <small>Platform</small>

                                    <strong>IBKR - Interactive Brokers</strong>

                                </div>

                                <div>

                                    <small>Updated</small>

                                    <strong>July 2026</strong>

                                </div>

                            </div>

                        </div>

                        <div className="col-md-4 text-end">

                            <button className="btn btn-primary download-btn">

                                🖥 Download iTWS Package

                            </button>

                        </div>

                    </div>

                </div>

            </div>



        );
    }
}

export default ITWSLiveTradingCard;